const steps = [
  {
    icon: "ri-eye-line",
    title: "找瓜围观",
    desc: "从热门现场或分类频道里挑一个感兴趣的瓜，点进去开始围观。",
  },
  {
    icon: "ri-send-plane-line",
    title: "弹幕互动",
    desc: "边看边发弹幕，和全场吃瓜群众一起吐槽，一秒不冷场。",
  },
  {
    icon: "ri-chat-1-line",
    title: "话题热议",
    desc: "加入话题广场的讨论，评论热议、观点交锋，聊到你尽兴。",
  },
  {
    icon: "ri-share-forward-line",
    title: "转发分享",
    desc: "把名场面分享给朋友，一起在评论区玩梗、复盘、吃到饱。",
  },
];

export default function HowItWorks() {
  return (
    <section id="play" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <p className="text-accent-600 font-heading text-sm mb-1">HOW IT WORKS</p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">四步加入吃瓜现场</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              从围观到参与，吃瓜视频网把"看热闹"变成"一起热闹"。不需要复杂操作，
              点开即看，弹幕即聊，话题即讨论。
            </p>
            <a
              href="#live"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 whitespace-nowrap transition-colors"
            >
              <i className="ri-play-circle-fill text-xl"></i>
              马上开始围观
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {steps.map((s, i) => (
              <div key={i} className="card-lift rounded-2xl p-4 md:p-5 hover:border-accent-200 transition-colors relative">
                <span className="absolute top-4 right-4 font-heading text-3xl text-background-200 select-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="w-11 h-11 rounded-xl bg-accent-100 text-accent-700 flex items-center justify-center mb-3">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mb-1">{s.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}